import * as routes from "view/routes";

export const checkAliasReserved = (alias: string) => {
  const paths = Object.values(routes);
  const reservedResources = new Set(
    paths.reduce<string[]>((acc, path) => {
      if (typeof path !== "string") {
        return acc;
      }

      const first = path.split("/")?.[1];
      if (first) {
        acc.push(first);
      }

      return acc;
    }, [])
  );

  return reservedResources.has(alias.toLowerCase());
};
